"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationContent = void 0;
const lib_1 = require("@brandfree-front/lib");
const react_1 = __importDefault(require("react"));
const RootStore_1 = require("../../../stores/RootStore");
const CommunicationContent = () => {
    const { translate } = react_1.default.useContext(RootStore_1.RootStoreContext).translateStore;
    return (react_1.default.createElement(lib_1.Text, null,
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.communication.content.text')),
        react_1.default.createElement(lib_1.List, null,
            react_1.default.createElement(lib_1.ListItem, null,
                react_1.default.createElement(lib_1.Text, null,
                    react_1.default.createElement("b", null, translate('gdpr.privacy.notification.communication.content.list1.header')),
                    react_1.default.createElement("p", { className: "text__margin-half" }, translate('gdpr.privacy.notification.communication.content.list1.body')))),
            react_1.default.createElement(lib_1.ListItem, null,
                react_1.default.createElement(lib_1.Text, null,
                    react_1.default.createElement("b", null, translate('gdpr.privacy.notification.communication.content.list2.header')),
                    react_1.default.createElement("p", { className: "text__margin-half" }, translate('gdpr.privacy.notification.communication.content.list2.body')))),
            react_1.default.createElement(lib_1.ListItem, null,
                react_1.default.createElement(lib_1.Text, null,
                    react_1.default.createElement("b", null, translate('gdpr.privacy.notification.communication.content.list3.header')),
                    react_1.default.createElement("p", { className: "text__margin-half" }, translate('gdpr.privacy.notification.communication.content.list3.body'))))),
        react_1.default.createElement("p", null,
            react_1.default.createElement("i", null, translate('gdpr.privacy.notification.communication.content.text2')))));
};
exports.CommunicationContent = CommunicationContent;
